import React from "react";
import { useParams,Link } from "react-router-dom";
import { SCHOOL_FACILITIES } from "../../constants";
import SeoContent from "../../components/shared/SeoContent";

export default function FacilityDetails() {
  const { slug } = useParams();
  const facility = SCHOOL_FACILITIES.find((f) => f.slug === slug);

  if (!facility) {
    return (
      <div className="p-10 text-center text-red-600">Facility not found.</div>
    );
  }

  return (
    <>
      <SeoContent title={facility.title} />
      <section className="section">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-800">{facility.title}</h1>
        </div>

        <div className="space-y-10">
          {facility.descriptions.map((desc, idx) => {
            const isEven = idx % 2 === 0;
            const image = facility.images[idx] || facility.images[0];

            return (
              <div
                key={idx}
                className="grid grid-cols-1 md:grid-cols-2 rounded-xl shadow-md overflow-hidden"
              >
              
                <div
                  className={`bg-primary text-white p-8 lg:p-16 flex flex-col justify-center ${
                    isEven ? "order-1" : "order-2"
                  }`}
                >
                  <p className="uppercase mb-2">Facility Detail</p>
                  <h2 className="text-2xl font-semibold mb-4">
                    {facility.title}
                  </h2>
                  <p className="font-normal mb-4">{desc}</p>
                  <Link
                    to={`/facilities/${slug}/detail`}
                    className="w-fit rounded bg-white px-4 py-2 text-primary hover:bg-gray-100"
                  >
                    Read More
                  </Link>
                </div>

                <div
                  className={`hidden md:block h-[400px] ${
                    isEven ? "order-2" : "order-1"
                  }`}
                >
                  <img
                    src={image}
                    alt={`facility-${idx}`}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}


{/* <section className="section">
  <div className="mb-8 text-center">
    <h1 className="text-3xl font-bold text-gray-800">{facility.title}</h1>
  </div>

  <div className="space-y-10">
    {facility.images.map((img, idx) => (
      <div key={idx} className="flex flex-col items-center space-y-4">
        <img
          src={img}
          alt={`image-${idx}`}
          className="h-64 w-full rounded-lg object-cover"
        />
        <p className="text-lg text-gray-700 max-w-3xl text-center">
          {facility.descriptions[idx] || ""}
        </p>
      </div>
    ))}
  </div>
</section> */}